<template>
  <div v-if="$store.state.responsive.viewDesktopFilters" id="cancellations-filters">
    <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
      <div class="row">
        <!-- <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="name">Nombre</label>
            <input type="text" class="form-control generalInput" id="name" v-model.trim="name">
          </div>
        </div> -->
        <!-- <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="surnames">Apellidos</label>
            <input type="text" class="form-control generalInput" id="surnames" v-model.trim="surnames">
          </div>
        </div> -->
        <!-- <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="documentNumber">DNI</label>
            <input type="text" class="form-control generalInput" id="documentNumber" v-model.trim="documentNumber">
          </div>
        </div> -->
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="contractNumber">Nº Contrato</label>
            <input type="text" class="form-control generalInput" id="contractNumber" v-model.trim="contractNumber">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="from">Desde</label>
            <DatePicker v-model="from" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="from" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="to">Hasta</label>
            <DatePicker v-model="to" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="to" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="status">Estado</label>
            <VueNextSelect class="form-control generalInput" :options="statuses" v-model.trim="status" placeholder=""
              close-on-select>
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-end align-items-end">
          <div class="h-100">
            <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
            <button class="btn btn-primary generalPrimaryButton">Buscar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <div class="filterHeader link-primary d-flex align-items-center justify-content-between" data-toggle="collapse" href="#filterCollapse" role="button" aria-expanded="false" aria-controls="filterCollapse">
      <p class="m-0">
        FILTROS
      </p>
      <v-icon name="bi-filter" scale="1.5" />
    </div>
    <hr/>
    <div class="collapse" id="filterCollapse">
      <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
        <div class="row">
          <!-- <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="name">Nombre</label>
              <input type="text" class="form-control generalInput" id="name" v-model.trim="name">
            </div>
          </div> -->
          <!-- <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="surnames">Apellidos</label>
              <input type="text" class="form-control generalInput" id="surnames" v-model.trim="surnames">
            </div>
          </div> -->
          <!-- <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="documentNumber">DNI</label>
              <input type="text" class="form-control generalInput" id="documentNumber" v-model.trim="documentNumber">
            </div>
          </div> -->
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="contractNumber">Nº Contrato</label>
              <input type="text" class="form-control generalInput" id="contractNumber" v-model.trim="contractNumber">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="from">Desde</label>
              <DatePicker v-model="from" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="from" />
                  <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
                </template>
              </DatePicker>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="to">Hasta</label>
              <DatePicker v-model="to" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="to" />
                  <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
                </template>
              </DatePicker>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="status">Estado</label>
              <VueNextSelect class="form-control generalInput" :options="statuses" v-model.trim="status" placeholder=""
                close-on-select>
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-end align-items-end">
            <div class="h-100">
              <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
              <button class="btn btn-primary generalPrimaryButton">Buscar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { DatePicker } from 'v-calendar';
import VueNextSelect from 'vue-next-select'
export default {
  name: 'ContractFilters',
  components: {
    DatePicker,
    VueNextSelect,
  },
  props: [
    'filterURL',
    ],
  data() {
    return {
      // name: '',
      contractNumber: '',
      from: '',
      to: '',
      // surnames: '',
      // documentNumber: '',
      status: '',
      modelConfig: {
        type: 'string',
        mask: 'DD/MM/YYYY',
      },
      statuses: ['CREATED', 'CANCELLED', 'EXPIRED', 'DELIVERED', 'REVISED WITHOUT DEFECTS', 'REVISED WITH DEFECTS', 'EXECUTED', 'COMPLETED', 'PROCESS STARTED', 'PAYMENT HOLD SUBMITTED', 'LOGISTIC PICKUP REQUESTED'],
    };
  },
  mounted() {
    if(this.filterURL && this.filterURL !== '') {
      let statusTemp = decodeURIComponent(this.filterURL);
      if (statusTemp === 'REVIEWED_OK') {
        statusTemp = 'REVISED WITHOUT DEFECTS';
      } else if (statusTemp === 'REVIEWED_DEFECTS') {
        statusTemp = 'REVISED WITH DEFECTS';
      }
      this.status = statusTemp;
      this.$nextTick(() => {
        this.filter();
      })
    }
  },
  computed: {
    filtersApplied() {
      // `this` apunta a la instancia vm
      return {
        // name: this.name,
        contractNumber: this.contractNumber,
        from: this.from,
        to: this.to,
        // surnames: this.surnames,
        // documentNumber: this.documentNumber,
        status: this.status
      };
    },
  },
  methods: {
    filter() {
      if (this.filtersApplied.status === 'REVISED WITHOUT DEFECTS') {
        this.filtersApplied.status = 'REVIEWED_OK';
      } else if (this.filtersApplied.status === 'REVISED WITH DEFECTS') {
        this.filtersApplied.status = 'REVIEWED_DEFECTS';
      } else if(this.filtersApplied.status === 'PROCESS STARTED') {
        this.filtersApplied.status = 'PROCESS_STARTED';
      } else if(this.filtersApplied.status === 'PAYMENT HOLD SUBMITTED') {
        this.filtersApplied.status = 'PAYMENT_HOLD_SUBMITTED';
      } else if(this.filtersApplied.status === 'LOGISTIC PICKUP REQUESTED') {
        this.filtersApplied.status = 'LOGISTIC_PICKUP_REQUESTED';
      }
      this.$emit('filter', this.filtersApplied);
    },
    cleanSearch() {
      // this.name = '';
      this.contractNumber = '';
      this.from = '';
      this.to = '';
      // this.surnames = '';
      // this.documentNumber = '';
      this.status = '';
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        this.filter();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../scss/variables.scss';

.filterHeader {
  font-size: 1.143rem;
  line-height: 1.5;
}
.link-primary {
  color:$primary;
  cursor:pointer;

  &:hover {
    color: $primary-hover;
  }
}
</style>
